import type { ApiResponseEnvelope, RequestContext } from '../fetch/apiClient';
import { login } from '../queryHooks/user';

export function newToken(
  respBody: ApiResponseEnvelope<unknown>,
  _respHeaders: Record<string, string>,
  _request: RequestContext,
): void {
  if (respBody.token) {
    login(respBody.token);
  }
}
